// extracted by mini-css-extract-plugin
export default {"root":"pageNotFound_root__6uttz"};